import { useSocketEvent as useSocketEventGeneric, useSocketSubscribe as useSocketSubscribeGeneric } from '@rad/hooks';
export * from './events';
// Typed wrappers for app-specific socket events
export function useSocketEvent(event, handler) {
    return useSocketEventGeneric(event, handler);
}
export function useSocketSubscribe() {
    return useSocketSubscribeGeneric();
}
